export default __webpack_public_path__ + "static/media/bg.27b96ef2.png";